/**
 * Product Info Alternate Section
 * Handles variant selection and dynamic updates
 */

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-info-alt').forEach(function(section) {
    var variantSelect = section.querySelector('.product-info-alt__variant-select');
    var priceDisplay = section.querySelector('[data-product-price]');
    var inventoryMessage = section.querySelector('[data-inventory-message]');
    var variantIdInput = section.querySelector('.product-variant-id');
    var addButton = section.querySelector('.product-info-alt__add-button');

    if (!variantSelect) return;

    variantSelect.addEventListener('change', function() {
      var selectedOption = this.options[this.selectedIndex];
      var variantId = selectedOption.value;
      var available = selectedOption.getAttribute('data-available') === 'true';
      var price = selectedOption.getAttribute('data-price');
      var inventory = parseInt(selectedOption.getAttribute('data-inventory'), 10);
      var buttonText = selectedOption.getAttribute('data-button-text');
      var soldOutText = selectedOption.getAttribute('data-sold-out-text');
      var inventoryTemplate = selectedOption.getAttribute('data-inventory-template');

      // Update hidden input
      if (variantIdInput) {
        variantIdInput.value = variantId;
        variantIdInput.disabled = !available;
      }

      // Update price
      if (priceDisplay && price) {
        priceDisplay.textContent = price;
      }

      // Update button state
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? buttonText : soldOutText;
      }

      // Update inventory message
      if (inventoryMessage) {
        if (available && inventory > 0 && inventoryTemplate) {
          inventoryMessage.textContent = inventoryTemplate.replace('[count]', inventory);
          inventoryMessage.style.display = '';
        } else {
          inventoryMessage.style.display = 'none';
        }
      }

      // Update URL with variant
      var url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    });
  });
});
